// extracted by mini-css-extract-plugin
module.exports = {"container":"data_container__qMr2X","data-top":"data_data-top__Goakc","data-bottom":"data_data-bottom__1Ymyi"};